module.exports = __webpack_public_path__ + "img/profile-style-img3.d4135396.png";